import { render, staticRenderFns } from "./getCurrentCity.vue?vue&type=template&id=2189acbe"
import script from "./getCurrentCity.vue?vue&type=script&lang=js"
export * from "./getCurrentCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports